import React, { Component } from 'react'
import renderHTML from 'react-render-html'
import ContactForm from './Contactform'
import PostRelDetail from './Postreldetail'
import MailSuscriptionContent from './Mailsuscription'

class PostContent extends Component {

  constructor(props){
    super(props)
    this.state = {
      dataPost: [],
      datarel:[],
      activeIndex: 1,
      left: 0,
      recomendados: false,
      contactForm:false,
      geoCity: '',
      geocountry: ''
    }
  }

  componentWillReceiveProps(next_props) {
    //console.log(next_props.content)
    this.setState({ 
      dataPost: next_props.content,
      datarel: next_props.relObj
    })

    if (next_props.contact !== this.state.contactForm){
       this.setState({ 
        contactForm: next_props.contact
      })
    }
    if(next_props.geoCity !== undefined || next_props.geoCity !== 'undefined'){
        let stringGeo = (next_props.geoCity)?next_props.geoCity.toLowerCase():''
        this.setState({
          geocountry: stringGeo
        });
      }
    if(this.state.geocountry === 'ar'){
      this.setState({ 
        geoCity: "/contacto-argentina/"
      })
    }
    if(this.state.geocountry === 'co'){
      this.setState({ 
        geoCity: "/contacto-colombia/"
      })
    }
    if(this.state.geocountry === 'cl'){
      this.setState({ 
        geoCity: "/contacto-chile/"
      })
    }
    if(this.state.geocountry === 'cent'){
      this.setState({ 
        geoCity: "/contacto-centro-america/"
      })
    }
    if(this.state.geocountry === 'do'){
      this.setState({ 
        geoCity: "/contacto-republica-dominicana/"
      })
    }
    if(this.state.geocountry === 've'){
      this.setState({ 
        geoCity: "/contacto-venezuela/"
      })
    }
  }

  render() {
    return (
      <div className="col s12 ">
        {
          this.state.dataPost.map((item, i) => { 
            const colorClass = `title_cat ${this.props.classColor}`
            let large = (item.custom_fields_object.imagen_principal && item.custom_fields_object.imagen_principal.value && item.custom_fields_object.imagen_principal.value.length > 0)?item.custom_fields_object.imagen_principal.value:''
            let medium = (item.custom_fields_object.imagen_principal && item.custom_fields_object.imagen_principal.value && item.custom_fields_object.imagen_principal.value.length > 0)?item.custom_fields_object.imagen_principal.value:''
            let small = (item.custom_fields_object.imagen_principal_mobile && item.custom_fields_object.imagen_principal_mobile.value && item.custom_fields_object.imagen_principal_mobile.value.length > 0)?item.custom_fields_object.imagen_principal_mobile.value:''
            return (
              <div className="container_post" key={i}>
                <div className="header_img">
                  { item.custom_fields_object.imagen_principal &&
                    <picture>
                      <source srcSet={small} media="(max-width: 425px)" />
                      <source srcSet={medium} media="(max-width: 768px)" />
                      <img src={large} alt={item.title.rendered} />
                    </picture>
                  }
                  { item.custom_fields_object.parrilla_programacion &&
                    <img src={item.custom_fields_object.parrilla_programacion.value.url} alt=""/>
                  }
                </div>
                <div className={(this.props.title_cat === 'Actualidad del mercado')?"cont_data not_sidebar": "cont_data"}>
                  { this.props.title_cat !== 'Actualidad del mercado' &&
                    <div className="col s12 m5 l4 col_data_rel">
                      <MailSuscriptionContent />
                      <div className="bg_trans"></div>
                      { item.custom_fields_object.parrilla_file && item.custom_fields_object.parrilla_file.value &&
                        <div className={colorClass}>
                          <a href={item.custom_fields_object.parrilla_file.value.url} target="_blank">
                            <i className="material-icons">cloud_download</i>
                            <h2>{this.props.nameFile}</h2>
                          </a>
                        </div>
                      }
                      <div className={colorClass}>
                        <h2>{this.props.title_cat}</h2>
                      </div>
                      <div className="file_post">
                        { item.custom_fields_object.imagen_descriptiva &&
                          <a href={this.state.geoCity}><img src={item.custom_fields_object.imagen_descriptiva.value.url} alt=""/></a>
                        }
                        {
                          item.custom_fields_object.imagen_canal &&
                          <div className="cont_brand">
                            <div className="file_post_brand">
                              <img src={item.custom_fields_object.imagen_canal.value.url} alt=""/>
                            </div>
                            <div className="file_post_title">
                              { item.custom_fields_object.descripcion_horario &&
                                <div>{renderHTML(item.custom_fields_object.descripcion_horario.value)}</div>
                              }
                            </div>
                          </div>
                        }
                        
                        { item.custom_fields_object.imagen_adjunta &&
                          <img src={item.custom_fields_object.imagen_adjunta.value.url} alt=""/>
                        }
                        { item.custom_fields_object.imagen_adjunta_2 &&
                          <img src={item.custom_fields_object.imagen_adjunta_2.value.url} alt=""/>
                        }
                        { item.custom_fields_object.imagen_adjunta_3 &&
                          <img src={item.custom_fields_object.imagen_adjunta_3.value.url} alt=""/>
                        }
                        { item.custom_fields_object.imagen_descriptiva_reco &&
                          <img src={item.custom_fields_object.imagen_descriptiva_reco.value.url} alt=""/>
                        }
                      </div>
                      {
                        item.custom_fields_object.info_contacto && 
                        <div className='cont-contact'>
                          {renderHTML(item.custom_fields_object.info_contacto.value)}
                        </div>
                      }
                    </div>
                  }
                  <div className={(this.props.title_cat === 'Actualidad del mercado')?"col s12 m12 l12 bg_data rel-blog": "col s12 m7 l8 bg_data"}>
                    <div className={(this.props.title_cat === 'Actualidad del mercado')?"row":"cont-sin-rel"}>
                      {
                        this.props.title_cat === 'Actualidad del mercado' &&
                        <div className="col s12 m4 l4 reil-content-detail">
                          <PostRelDetail post={(this.props.reldatapost)?this.props.reldatapost :[] } classColor={colorClass}/>
                        </div>
                      }
                      {
                        this.props.title_cat === 'Actualidad del mercado' &&
                        <div className="col s12 m8 l8 content-detail">
                          <div className="title_post">
                            <h1>{renderHTML(item.title.rendered)}</h1>
                          </div>
                          <div dangerouslySetInnerHTML={{ __html: item.content.rendered }}></div>
                          {
                            this.state.contactForm &&
                            <ContactForm geo={this.props.geo}/>
                          }
                        </div>
                      }
                      {
                        this.props.title_cat !== 'Actualidad del mercado' &&
                        <div className="col s12 m12 l12">
                          <div className="title_post">
                            <h1>{renderHTML(item.title.rendered)}</h1>
                          </div>
                          <div dangerouslySetInnerHTML={{ __html: item.content.rendered }}></div>
                          {
                            this.state.contactForm &&
                            <ContactForm geo={this.props.geo}/>
                          }
                        </div>
                      }
                    </div>
                  </div>
                </div>
                {
                  item.galleryObj && 
                  <div className="col s12 gallery_pri">
                    <div className="col s12 m6 l6">
                      <img src={item.galleryObj.src[0]} alt=""/>
                    </div>
                    <div className="col s12 m6 l6">
                      {
                        item.galleryObj.src.slice(1).map((image, i) => {
                          return(
                            <img src={image} alt=""/>
                          )
                        })
                      }
                    </div>
                  </div>
                }
              </div>
            )
            
          })
        }
      </div>
    )
  }
}

export default PostContent



// WEBPACK FOOTER //
// ./src/Post.js